import { render, staticRenderFns } from "./VuetableColGutter.vue?vue&type=template&id=9e0a75e8"
import script from "./VuetableColGutter.vue?vue&type=script&lang=js"
export * from "./VuetableColGutter.vue?vue&type=script&lang=js"
import style0 from "./VuetableColGutter.vue?vue&type=style&index=0&id=9e0a75e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports